import React, {useEffect} from 'react';
import ReportUtils from "../../../../../../utils/report-utils.js";
import reportUtils from "../../../../../../utils/report-utils.js";

const summaryLabels = [
  "Marcadores cadastrados",
  "Passagens marcadas",
];

const langLane = (lane) => {
  switch (lane) {
    case "ENTRANCE": return "ENTRADA";
    case "EXIT": return "SAÍDA";
    case "INTERNAL": return "INTERNO";
    case "MOBILE": return "FAIXA MÓVEL";
    default: return lane;
  }
};
const PassageLabelsCards = ({passagesLabelTotal, passagesTotal, passageLabelsList}) => {

  useEffect(() => {
    const summaryValues = [
      passagesLabelTotal,
      passagesTotal
    ];

    if(passageLabelsList.length > 0){
      const headers = ["ID", "Nome do marcador", "Placa", "Data de captura", "Dia da semana", "Ponto de coleta", "Faixa", "Sentido", "Criado por"]
      const rows = passageLabelsList.map(el => {
        const { id, name, plate, date, dow, capture_place, lane, way, user_created } = el;

        return [
          id,
          name,
          plate,
          date,
          dow,
          capture_place,
          lane,
          langLane(way),
          user_created
        ];
      });
      reportUtils.createExportableTable(headers, rows, "Lista de marcadores");
    }

    ReportUtils.createExportableTable(summaryLabels, summaryValues, "Cards");
  }, [passagesLabelTotal, passagesTotal]);

  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <div className="mb-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[0]}</h3><h2>{passagesTotal ?? 0}</h2>
            </div>
          </div>
        </div>
        <div className="mb-1">
          <div className="text-center">
            <div className="box boxCount cursor-pointer">
              <h3>{summaryLabels[1]}</h3><h2>{passagesLabelTotal ?? 0}</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="chart-divisor"></div>
    </>
  );
};

export default PassageLabelsCards;